<template>
  <div>
    <breadcrumbs home="User"/>

    <v-card flat width="100%">
      <v-form v-model="valid" ref="form">
        <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Name" v-model="user.name" outlined dense :disabled="userId!=undefined"
                            hint="Only used if the user does not already exist"/>
            </v-col>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Email" v-model="user.email" :rules="[fieldRules.required,fieldRules.maxLength(50),fieldRules.email]" outlined dense :disabled="userId!=undefined"
                            :hint="userId==null?'If user doesn\'t exist, they will be invited to join PŪRTRAK':''"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Configuration read" v-model="permissions.configRead" :disabled="permissions.configWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Configuration write" v-model="permissions.configWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to distillery information, settings and preferences, site management, user management, currencies and accouting connection functions
            </v-col>
          </v-row>
          <v-row dense v-if="$store.getters.company.allowAudit">
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Audit" v-model="permissions.audit"/>
            </v-col>
            <v-col cols="12" offset-md="4" offset-lg="3" md="5" class="text-caption" align-self="center">
              Allows viewing audit logs
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Values" v-model="permissions.values"/>
            </v-col>
            <v-col cols="12" offset-md="4" offset-lg="3" md="5" class="text-caption" align-self="center">
              Allows values to be visible.
              If not selected and connected to QuickBooks Online, shipments and invoice receipts will
              remain in a pending status until someone with Values permission updates them.
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Production read" v-model="permissions.productionRead" :disabled="permissions.productionWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Production write" v-model="permissions.productionWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to all production functions like mashing, distilling, blending and bottling
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Inventory read" v-model="permissions.inventoryRead"
                      :disabled="permissions.inventoryWrite || permissions.productionWrite || permissions.sellingWrite || permissions.buyingWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Inventory write" v-model="permissions.inventoryWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to all inventory including raw materials, finished product, and bulk alcohol
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Purchasing read" v-model="permissions.buyingRead" :disabled="permissions.buyingWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Purchasing write" v-model="permissions.buyingWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to suppliers, purchase orders and inventory receipts
            </v-col>
          </v-row>
          <v-row dense v-if="$store.getters.company.allowPO">
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="PO approve" v-model="permissions.poApprove" :disabled="!permissions.buyingRead"/>
            </v-col>
            <v-col cols="12" offset-md="4" offset-lg="3" md="5" class="text-caption" align-self="center">
              Allows approval of purchase orders, if required by distillery preferences
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Sales read" v-model="permissions.sellingRead" :disabled="permissions.sellingWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Sales write" v-model="permissions.sellingWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to customers, sales orders, shipments and invoices
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Reports" v-model="permissions.reports"/>
            </v-col>
            <v-col cols="12" offset-md="4" offset-lg="3" md="5" class="text-caption" align-self="center">
              Allows access to all reports
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="File excise returns" v-model="permissions.exciseFile"/>
            </v-col>
            <v-col cols="12" offset-md="4" offset-lg="3" md="5" class="text-caption" align-self="center">
              Allows CRA excise returns to be filed
            </v-col>
          </v-row>
          <v-row dense v-if="$store.getters.company.allowPlanning">
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Forecasting read" v-model="permissions.forecastingRead" :disabled="permissions.forecastingWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Forecasting write" v-model="permissions.forecastingWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to forecasting
            </v-col>
          </v-row>
          <v-row dense v-if="$store.getters.company.allowPlanning">
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Scheduling read" v-model="permissions.schedulingRead" :disabled="permissions.schedulingWrite"/>
            </v-col>
            <v-col cols="6" md="3" lg="2">
              <v-checkbox label="Scheduling write" v-model="permissions.schedulingWrite"/>
            </v-col>
            <v-col cols="12" offset-md="1" md="5" class="text-caption" align-self="center">
              Allows access to scheduling
            </v-col>
          </v-row>

        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
    </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SettingsUsersEdit',
  mixins: [confirmLeave],
  props: {
    userId: {type:String, required:false}
  },
  data() {
    return {
      user: {email:'',name:''},
      valid: true,
      dirty: false,
      saving: false,
      permissions: {
        configWrite: false, configRead: false, audit: false, values: true,
        productionWrite:true,productionRead:true,
        inventoryWrite:true,inventoryRead:true,
        buyingWrite:true,buyingRead:true,poApprove:true,
        sellingWrite:true,sellingRead:true,
        reports:true,
        exciseFile: true,
        schedulingWrite:false,schedulingRead:false,forecastingWrite:false,forecastingRead:false
      }
    }
  },
  watch: {
    user: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    },
    permissions: {
      handler() {
        this.dirty = true;
        if (this.permissions.configWrite)
          this.permissions.configRead = true;
        if (this.permissions.productionWrite) {
          this.permissions.productionRead = true;
          this.permissions.inventoryRead = true;
        }
        if (this.permissions.inventoryWrite)
          this.permissions.inventoryRead = true;
        if (this.permissions.buyingWrite) {
          this.permissions.buyingRead = true;
          this.permissions.inventoryRead = true;
        }
        if (this.permissions.sellingWrite) {
          this.permissions.sellingRead = true;
          this.permissions.inventoryRead = true;
        }
        if (this.permissions.forecastingWrite)
          this.permissions.forecastingRead = true;
        if (this.permissions.schedulingWrite)
          this.permissions.schedulingRead = true;
      },
      immediate: true,
      deep: true
    },
  },

  async created() {
    if (this.userId) {
      const results = await this.$apiCall(`query SettingsUsersEdit($id:String!) {
                                             company {
                                                user(userId:$id) {
                                                  userId,name,email,permissions
                                                }
                                              }
                                            }`,
                                          {id:this.userId});
      if (!results.error) {
        this.user = results.data.company.user;
        this.permissions = {
          configWrite: this.user.permissions.includes('config.write'),
          configRead: this.user.permissions.includes('config.read'),
          audit: this.user.permissions.includes('audit'),
          values: this.user.permissions.includes('values'),
          productionWrite: this.user.permissions.includes('production.write'),
          productionRead: this.user.permissions.includes('production.read'),
          inventoryWrite: this.user.permissions.includes('inventory.write'),
          inventoryRead: this.user.permissions.includes('inventory.read'),
          buyingWrite: this.user.permissions.includes('buying.write'),
          buyingRead: this.user.permissions.includes('buying.read'),
          poApprove: this.user.permissions.includes('po.approve'),
          sellingWrite: this.user.permissions.includes('selling.write'),
          sellingRead: this.user.permissions.includes('selling.read'),
          reports: this.user.permissions.includes('reports'),
          exciseFile: this.user.permissions.includes('excise.file'),
          forecastingWrite: this.user.permissions.includes('forecasting.write'),
          forecastingRead: this.user.permissions.includes('forecasting.read'),
          schedulingWrite: this.user.permissions.includes('scheduling.write'),
          schedulingRead: this.user.permissions.includes('scheduling.read'),
        };
        this.$nextTick(() => {
          this.dirty = false;
        });
      }
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.saving = true;
      this.user.permissions = '';
      this.user.permissions += this.permissions.configRead ? 'config.read ' : '';
      this.user.permissions += this.permissions.configWrite ? 'config.write ' : '';
      this.user.permissions += this.permissions.audit ? 'audit ' : '';
      this.user.permissions += this.permissions.values ? 'values ' : '';
      this.user.permissions += this.permissions.productionRead ? 'production.read ' : '';
      this.user.permissions += this.permissions.productionWrite ? 'production.write ' : '';
      this.user.permissions += this.permissions.inventoryRead ? 'inventory.read ' : '';
      this.user.permissions += this.permissions.inventoryWrite ? 'inventory.write ' : '';
      this.user.permissions += this.permissions.buyingRead ? 'buying.read ' : '';
      this.user.permissions += this.permissions.poApprove ? 'po.approve ' : '';
      this.user.permissions += this.permissions.buyingWrite ? 'buying.write ' : '';
      this.user.permissions += this.permissions.sellingRead ? 'selling.read ' : '';
      this.user.permissions += this.permissions.sellingWrite ? 'selling.write ' : '';
      this.user.permissions += this.permissions.reports ? 'reports ' : '';
      this.user.permissions += this.permissions.exciseFile ? 'excise.file ' : '';
      this.user.permissions += this.permissions.forecastingRead ? 'forecasting.read ' : '';
      this.user.permissions += this.permissions.forecastingWrite ? 'forecasting.write ' : '';
      this.user.permissions += this.permissions.schedulingRead ? 'scheduling.read ' : '';
      this.user.permissions += this.permissions.schedulingWrite ? 'scheduling.write ' : '';

      let results;
      if (this.userId)
        results = await this.$apiCall(`mutation SettingsUsersEdit($userId: String!, $permissions: String!) {
                                        companyUserUpdate(userId:$userId, permissions:$permissions) {userId}
                                      }`,
                                  {userId:this.userId,permissions:this.user.permissions});
      else
        results = await this.$apiCall(`mutation SettingsUsersEdit($input: CompanyUserCreateInput!) {
                                          companyUserCreate(input:$input) {userId}
                                        }`,
                                    {input:this.user});

      this.saving = false;
      if (results.error)
        return;

      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',
                                        message:`${this.userId?'Updated':'Created'} user ${this.user.email}${this.userId?'':`. (Make sure ${this.user.email} checks their junk email folder.)`}`});
      });
    },
  }
}
</script>